// 抛出登录请求状态
import {
	getCategoryList
} from '@/api/goods'
const state = {
	categoryList:[]
}

const mutations = {
	SET_CATEGORY: (state, list) => {
		state.categoryList = list
	}
}

const actions = {
	// get user info
	getCategoryList({
		commit,
		state
	}) {
		return new Promise((resolve, reject) => {
			getCategoryList().then(response => {
				commit('SET_CATEGORY', response.data)
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
